import React from "react";
import styled from "styled-components";
import { font, theme } from "styles";

type Props = {
  children: string;
  onClick: () => void;
  isBold?: boolean;
};

export const RecipientsSelectionRemoveButton = ({ children, onClick, isBold }: Props) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    onClick();
  };

  return (
    <StyledButton onClick={handleClick}>
      <StyledButtonLabel isBold={isBold}>{children}</StyledButtonLabel>
    </StyledButton>
  );
};

/**
 * Styles
 */

type StyledButtonLabelProps = Pick<Props, "isBold">;

const StyledButtonLabel = styled("span").withConfig({
  shouldForwardProp: (prop) => !["isBold"].includes(prop),
})<StyledButtonLabelProps>`
  position: relative;
  font-size: 12px;
  font-weight: ${(props) => (props.isBold ? font.weight.bold : font.weight.medium)};
  color: ${theme.recipientsSelectionRemoveButton.fontColor.default};
`;

const StyledButton = styled("button")`
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  padding: 5px;
  border: none;
  border-radius: 5px;
  margin: 0;
  text-decoration: none;
  cursor: pointer;

  &:hover ${StyledButtonLabel} {
    color: ${theme.recipientsSelectionRemoveButton.fontColor.hover};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 5px ${theme.recipientsSelectionRemoveButton.outlineColor};

    & ${StyledButtonLabel} {
      color: ${theme.recipientsSelectionRemoveButton.fontColor.focus};
    }
  }

  &:active ${StyledButtonLabel} {
    color: ${theme.recipientsSelectionRemoveButton.fontColor.active};
  }

  &:disabled {
    cursor: not-allowed;

    & ${StyledButtonLabel} {
      color: ${theme.recipientsSelectionRemoveButton.fontColor.disabled};
    }
  }
`;
